import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImportTemplateRoutingModule } from './import-template-routing.module';
import {ImportTemplateComponent} from './import-template.component';
import {Trip2ThemeModule} from '../../trip2-theme/trip2-theme.module';
import { ChargeFilesComponent } from './component/charge-files/charge-files.component';
import { FunctionComponent } from './component/function/function.component';
import { SplitComponent } from './component/split/split.component';
import { ConcatComponent } from './component/concat/concat.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FilterPipePipe} from './component/concat/filter-pipe.pipe';
import { MappingComponent } from './component/mapping/mapping.component';
import { ParseComponent } from './component/parse/parse.component';
import { SettingFormComponent } from './component/setting-form/setting-form.component';
import { DefineColumnsComponent } from './component/define-columns/define-columns.component';
import {ImportTemplateService} from './import-template.service';
import {AgGridModule} from 'ag-grid-angular';
import { SubstringComponent } from './component/substring/substring.component';
import { MultiDropdownImportComponent } from './multi-dropdown-import/multi-dropdown-import.component';


@NgModule({
  imports: [
    AgGridModule.withComponents([]),
    CommonModule,
    ImportTemplateRoutingModule,
    Trip2ThemeModule,
    ReactiveFormsModule,
    FormsModule
  ],
  declarations: [
    ImportTemplateComponent,
    ChargeFilesComponent,
    FunctionComponent,
    SplitComponent,
    ConcatComponent,
    SettingFormComponent,
    FilterPipePipe,
    MappingComponent,
    ParseComponent,
    DefineColumnsComponent,
    SubstringComponent,
    MultiDropdownImportComponent,
  ],
  providers: [ImportTemplateService]
})
export class ImportTemplateModule { }



// WEBPACK FOOTER //
// ./src/app/pages/import-template/import-template.module.ts